import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'tutor.reminderModal.firstShowTitle': {
    id: 'tutor.reminderModal.firstShowTitle',
    defaultMessage:
      "Hi! I'm the AI tutor for this course and can help you better understand the materials. Write me 'hello' to get started 😊",
  },
  'tutor.reminderModal.inputPlaceholder': {
    id: 'tutor.reminderModal.inputPlaceholder',
    defaultMessage: 'Hi, what can you do?',
  },
  'tutor.reminderModal.variant.0': {
    id: 'tutor.reminderModal.variant.0',
    defaultMessage: "I'm here if you need help with the course materials. Write to me.",
  },
  'tutor.reminderModal.variant.1': {
    id: 'tutor.reminderModal.variant.1',
    defaultMessage:
      'Is there anything in the topic that needs a simpler explanation? Feel free to ask me.',
  },
  'tutor.reminderModal.variant.2': {
    id: 'tutor.reminderModal.variant.2',
    defaultMessage: "If something seemed difficult — write to me, we'll work through it together.",
  },
  'tutor.reminderModal.variant.3': {
    id: 'tutor.reminderModal.variant.3',
    defaultMessage: 'I can explain this material in different words. Write your question.',
  },
  'tutor.reminderModal.variant.4': {
    id: 'tutor.reminderModal.variant.4',
    defaultMessage: "Need a hint on the topic? I'm here to help.",
  },
  'tutor.reminderModal.variant.5': {
    id: 'tutor.reminderModal.variant.5',
    defaultMessage: 'Not sure you understood the topic correctly? Please ask me.',
  },
  'tutor.reminderModal.variant.6': {
    id: 'tutor.reminderModal.variant.6',
    defaultMessage: 'I can briefly summarize the material for you. Write to me 🙂',
  },
  'tutor.reminderModal.variant.7': {
    id: 'tutor.reminderModal.variant.7',
    defaultMessage: 'Want to check your understanding of the topic? Ask me a question.',
  },
  'tutor.reminderModal.variant.8': {
    id: 'tutor.reminderModal.variant.8',
    defaultMessage: "If you have doubts — it's better to clarify them right away. Write to me.",
  },
  'tutor.reminderModal.variant.9': {
    id: 'tutor.reminderModal.variant.9',
    defaultMessage: "I'll help break down a complex topic into simple steps.",
  },
  'tutor.reminderModal.variant.10': {
    id: 'tutor.reminderModal.variant.10',
    defaultMessage: 'We can go through the key ideas of the topic together. Write to me.',
  },
  'tutor.reminderModal.variant.11': {
    id: 'tutor.reminderModal.variant.11',
    defaultMessage: "If something doesn't add up — let's figure it out together.",
  },
  'tutor.reminderModal.variant.12': {
    id: 'tutor.reminderModal.variant.12',
    defaultMessage: "I'm here to help you understand the material better.",
  },
  'tutor.reminderModal.variant.13': {
    id: 'tutor.reminderModal.variant.13',
    defaultMessage: 'Is everything clear in this section? I can explain in more detail.',
  },
  'tutor.reminderModal.variant.14': {
    id: 'tutor.reminderModal.variant.14',
    defaultMessage: 'Write to me if you want an example for this topic.',
  },
  'tutor.reminderModal.variant.15': {
    id: 'tutor.reminderModal.variant.15',
    defaultMessage: 'I can give examples to make it clearer.',
  },
  'tutor.reminderModal.variant.16': {
    id: 'tutor.reminderModal.variant.16',
    defaultMessage: "If you'd like — I'll explain this as simply as possible.",
  },
  'tutor.reminderModal.variant.17': {
    id: 'tutor.reminderModal.variant.17',
    defaultMessage: 'I can help you find the answer in the course materials.',
  },
  'tutor.reminderModal.variant.18': {
    id: 'tutor.reminderModal.variant.18',
    defaultMessage: 'I can explain this step by step. Do you need help?',
  },
  'tutor.reminderModal.variant.19': {
    id: 'tutor.reminderModal.variant.19',
    defaultMessage: "Need a quick explanation of the topic? I'm here 🙂",
  },
  'tutor.reminderModal.variant.20': {
    id: 'tutor.reminderModal.variant.20',
    defaultMessage: 'Write if you want to quickly review the main points of the topic.',
  },
  'tutor.reminderModal.variant.21': {
    id: 'tutor.reminderModal.variant.21',
    defaultMessage: "I'll help structure the information from this lesson. Shall we start?",
  },
  'tutor.reminderModal.variant.22': {
    id: 'tutor.reminderModal.variant.22',
    defaultMessage: 'Have questions about the material? Ask me anytime.',
  },
  'tutor.reminderModal.variant.23': {
    id: 'tutor.reminderModal.variant.23',
    defaultMessage: 'I can suggest what to pay attention to in this topic.',
  },
  'tutor.reminderModal.variant.24': {
    id: 'tutor.reminderModal.variant.24',
    defaultMessage: "If you'd like — I'll help you understand complex terms.",
  },
  'tutor.reminderModal.variant.25': {
    id: 'tutor.reminderModal.variant.25',
    defaultMessage: "I'm here to make learning easier for you.",
  },
  'tutor.reminderModal.variant.26': {
    id: 'tutor.reminderModal.variant.26',
    defaultMessage: 'Write if you want to better understand the key ideas.',
  },
  'tutor.reminderModal.variant.27': {
    id: 'tutor.reminderModal.variant.27',
    defaultMessage: 'I can explain the material in a format convenient for you.',
  },
  'tutor.reminderModal.variant.28': {
    id: 'tutor.reminderModal.variant.28',
    defaultMessage: "If something raises questions — don't leave it unanswered 🙂",
  },
  'tutor.reminderModal.variant.29': {
    id: 'tutor.reminderModal.variant.29',
    defaultMessage: 'Want more examples? I can help.',
  },
  'tutor.reminderModal.variant.30': {
    id: 'tutor.reminderModal.variant.30',
    defaultMessage: "I can explain this in a way that's easy to remember.",
  },
  'tutor.reminderModal.variant.31': {
    id: 'tutor.reminderModal.variant.31',
    defaultMessage: "If the topic seems difficult — let's work through it together.",
  },
  'tutor.reminderModal.variant.32': {
    id: 'tutor.reminderModal.variant.32',
    defaultMessage: 'Write if you want to clarify any point.',
  },
  'tutor.reminderModal.variant.33': {
    id: 'tutor.reminderModal.variant.33',
    defaultMessage: "I'll help you find the information you need in the course.",
  },
  'tutor.reminderModal.variant.34': {
    id: 'tutor.reminderModal.variant.34',
    defaultMessage: 'We can explore this topic more deeply together.',
  },
  'tutor.reminderModal.variant.35': {
    id: 'tutor.reminderModal.variant.35',
    defaultMessage: 'If something is unclear — this is a good moment to ask a question.',
  },
  'tutor.reminderModal.variant.36': {
    id: 'tutor.reminderModal.variant.36',
    defaultMessage: 'I can rephrase the material in simpler words.',
  },
  'tutor.reminderModal.variant.37': {
    id: 'tutor.reminderModal.variant.37',
    defaultMessage: 'Write if you want to check your understanding.',
  },
  'tutor.reminderModal.variant.38': {
    id: 'tutor.reminderModal.variant.38',
    defaultMessage: 'I can help connect this topic with previous ones.',
  },
  'tutor.reminderModal.variant.39': {
    id: 'tutor.reminderModal.variant.39',
    defaultMessage: "If you've been here a while — perhaps you have a question?",
  },
  'tutor.reminderModal.variant.40': {
    id: 'tutor.reminderModal.variant.40',
    defaultMessage: "I'll help make the topic clearer.",
  },
  'tutor.reminderModal.variant.41': {
    id: 'tutor.reminderModal.variant.41',
    defaultMessage: 'Need a small hint? Write to me.',
  },
  'tutor.reminderModal.variant.42': {
    id: 'tutor.reminderModal.variant.42',
    defaultMessage: 'I can help you understand without unnecessary complexity.',
  },
  'tutor.reminderModal.variant.43': {
    id: 'tutor.reminderModal.variant.43',
    defaultMessage: "If something isn't obvious — let's clarify it together.",
  },
  'tutor.reminderModal.variant.44': {
    id: 'tutor.reminderModal.variant.44',
    defaultMessage: "I'm here to support you in learning 🙂 Start asking questions.",
  },
  'tutor.reminderModal.variant.45': {
    id: 'tutor.reminderModal.variant.45',
    defaultMessage: 'Write if you want to better consolidate the material.',
  },
  'tutor.reminderModal.variant.46': {
    id: 'tutor.reminderModal.variant.46',
    defaultMessage: 'I can help highlight the main points of the topic.',
  },
  'tutor.reminderModal.variant.47': {
    id: 'tutor.reminderModal.variant.47',
    defaultMessage: 'If you have questions — now is the best time to ask them.',
  },
  'tutor.reminderModal.variant.48': {
    id: 'tutor.reminderModal.variant.48',
    defaultMessage: "I'll help make the material clearer and more logical for you.",
  },
  'tutor.reminderModal.variant.49': {
    id: 'tutor.reminderModal.variant.49',
    defaultMessage: 'Want a short explanation? Write to me.',
  },
  'tutor.reminderModal.variant.50': {
    id: 'tutor.reminderModal.variant.50',
    defaultMessage: 'I can help break the topic down into clear parts.',
  },
  'tutor.reminderModal.variant.51': {
    id: 'tutor.reminderModal.variant.51',
    defaultMessage: "If a question comes up — don't put it off, write now.",
  },
  'tutor.reminderModal.variant.52': {
    id: 'tutor.reminderModal.variant.52',
    defaultMessage: "I'll help you move forward with more confidence. What are your questions?",
  },
  'tutor.reminderModal.variant.53': {
    id: 'tutor.reminderModal.variant.53',
    defaultMessage: 'Write if you want to understand the details better.',
  },
  'tutor.reminderModal.variant.54': {
    id: 'tutor.reminderModal.variant.54',
    defaultMessage: 'I can explain this with an example. Shall I add more?',
  },
  'tutor.reminderModal.variant.55': {
    id: 'tutor.reminderModal.variant.55',
    defaultMessage: "If something remains unclear — let's clarify it.",
  },
  'tutor.reminderModal.variant.56': {
    id: 'tutor.reminderModal.variant.56',
    defaultMessage: "I'm here to answer your questions on the topic. Write to me.",
  },
  'tutor.reminderModal.variant.57': {
    id: 'tutor.reminderModal.variant.57',
    defaultMessage: 'Write if you want to understand the material more deeply.',
  },
  'tutor.reminderModal.variant.58': {
    id: 'tutor.reminderModal.variant.58',
    defaultMessage: 'I can help make learning clearer and easier.',
  },
});

export default messages;
